module.exports = __webpack_public_path__ + "img/电话白色图标.007c3698.svg";